import { login, logout, getUserInfo } from '@/api/account'
import _ from 'lodash'

const user = {
  state: {
    account: '',
    nickName: '',
    accountId: '',
    headPic: '',
    tenantName: '',
    tenantSystemName: '',
    tenantSystemLogo: '',
    notice: ''
  },

  mutations: {
    SET_ACCOUNT: (state, info) => {
      state.account = info
    },
    SET_NICKNAME: (state, info) => {
      state.nickName = info
    },
    SET_ACCOUNT_ID: (state, info) => {
      state.accountId = info
    },
    SET_HEADPIC: (state, info) => {
      state.headPic = info
    },
    SET_TENANTNAME: (state, info) => {
      state.tenantName = info
    },
    SET_TENANTSYSTEMNAME: (state, info) => {
      state.tenantSystemName = info
    },
    SET_TENANTSYSTEMLOGO: (state, info) => {
      state.tenantSystemLogo = info
    },
    SET_NOTICE: (state, info) => {
      state.notice = info
    }
  },

  actions: {
    // 登录
    Login ({ commit, state }, userParams) {
      const {
        tenantCode,
        account,
        password,
        code
      } = userParams
      return new Promise((resolve, reject) => {
        login(tenantCode, account, password, code).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve) => {
        getUserInfo().then(response => {
          commit('SET_ACCOUNT', _.get(response, 'data.account', ''))
          commit('SET_NICKNAME', _.get(response, 'data.english_name', ''))
          commit('SET_ACCOUNT_ID', _.get(response, 'data.uid', ''))
          commit('SET_HEADPIC', _.get(response, 'data.headpic_url', ''))
          commit('SET_TENANTNAME', _.get(response, 'data.tenant_name', ''))
          commit('SET_TENANTSYSTEMNAME', _.get(response, 'data.tenant_system_name', ''))
          commit('SET_TENANTSYSTEMLOGO', _.get(response, 'data.tenant_system_logo', ''))
          commit('SET_NOTICE', _.get(response, 'data.notice', ''))
          resolve(response)
        }).catch(error => {
          resolve(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    }

  }
}

export default user
